if (!customElements.get("lsg-blockquote-carousel")) customElements.define("lsg-blockquote-carousel", class LSGBlockquoteCarousel extends HTMLElement {
    constructor(){
        super();
        this.selectors = {
            carouselSectionEls: ".lsg-blockquote__section"
        };
        this.carouselSectionEls = this.querySelectorAll(this.selectors.carouselSectionEls);
        this.init();
    }
    init() {

        // buildQuoteSwitcher(this);

        function buildQuoteSwitcher(sectionEl) {
            const buttonEls = sectionEl.querySelectorAll(`[lsg-blockquote-button]`),
                  quoteEls  = sectionEl.querySelectorAll(`[lsg-blockquote-quote]`);

            buttonEls.forEach((buttonEl) => {
                buttonEl.addEventListener(`click`, (e) => {
                    const clickedEl = e.target;

                    let quoteId = clickedEl.getAttribute(`lsg-blockquote-button`);

                    const quoteEl = sectionEl.querySelector(`[lsg-blockquote-quote="${quoteId}"]`);

                    quoteEls.forEach((quoteEl) => {
                        quoteEl.classList.remove(`lsg-blockquote__active`);
                    });

                    buttonEls.forEach((buttonEl) => {
                        buttonEl.parentElement.classList.remove(`lsg-blockquote__active`);
                    });

                    clickedEl.parentElement.classList.add(`lsg-blockquote__active`);
                    quoteEl.classList.add(`lsg-blockquote__active`);
                });
            });
        }

        buildCarousel(this);

        function buildCarousel(carouselSectionEl) {
            const sectionId         = carouselSectionEl.getAttribute(`data-section-id`),
                  carouselSettings  = JSON.parse(document.getElementById(`CarouselSettings-${sectionId}`).textContent),
                  carouselActualEl  = carouselSectionEl.querySelector(`[lsg-carousel]`);

            let carouselEl;

            if (carouselActualEl) {
                function initCarousel(element, settings) {
                    const isMobile = window.innerWidth < 600;
                    const isSliderBehaviourSecondary = carouselSectionEl.classList.contains('lsg-blockquote__section--secondary');

                    // Non-customizable settings
                    settings.prevNextButtons = false;
                    settings.pageDots = false;
                    settings.percentPosition = false;
                    settings.imagesLoaded = true;
                    settings.setGallerySize = false;
                    settings.draggable = isMobile;
                    settings.on = {
                        change: function( index ) {
                            const quoteEls  = carouselSectionEl.querySelectorAll(`[lsg-blockquote-quote]`);
                            const quoteEl = carouselSectionEl.querySelector(`[lsg-blockquote-quote="${index}"]`);

                            quoteEls.forEach((quoteEl) => {
                                quoteEl.classList.remove(`lsg-blockquote__active`);
                            });
                            quoteEl.classList.add(`lsg-blockquote__active`);
                        },
                        staticClick: function( event, pointer, cellElement, index ) {
                            carouselEl.select(index);
                        },
                    }

                    if (isSliderBehaviourSecondary) {
                        settings.autoPlay = 5000;
                        if (isMobile) {
                            settings.contian = false;
                            settings.wrapAround = true;
                            settings.pageDots = true;
                            settings.cellAlign = 'center';
                        }
                    }

                    carouselEl = new window.Flickity(element, settings);

                    carouselEl.on('dragStart', () => {
                        carouselEl.slider.style.pointerEvents = 'none';
                    });
                    carouselEl.on('dragEnd', () => {
                        carouselEl.slider.style.pointerEvents = '';
                    });

                    carouselEl.on(`settle`, (e) => {
                        console.log(`[NSS] Carousel settled`);
                        // widthChecker();
                        // setSliderHeightToMax(carouselEl);
                    });
                }

                initCarousel(carouselActualEl, carouselSettings);

                /* Width Checker */
                function widthChecker() {
                    if (carouselEl && carouselActualEl.clientWidth > carouselEl.slideableWidth) {
                        carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                        carouselEl.destroy();
                    } else if (!carouselEl || !carouselEl.isActive) carouselEl = new window.Flickity(carouselActualEl, carouselSettings);
                }

                /* Height Handler */
                function setSliderHeightToMax(carouselEl) {
                    carouselEl.cells.forEach((cell)=>cell.element.style.height = "");
                    let heights = carouselEl.cells.map((cell)=>cell.element.offsetHeight), max = Math.max.apply(Math, heights);
                    carouselEl.cells.forEach((cell)=>cell.element.style.height = max + "px");
                }

                /* Resize Handling */
                window.addEventListener("resize", ()=>{
                    carouselEl.resize();
                    // widthChecker();
                    // setSliderHeightToMax(carouselEl);
                });
            }
        }

    }
});
